import {
  MSG_SERVICE,
  MSG_ORDER_NG,
  MSG_CART,
  MSG_ORDER,
} from "../constants/messages";

import { PROVIDE_STATUS } from "../constants/order_constants";

export const isSoldOutMenu = function (menu) {
  // メニュー「本体」が売切かどうか
  if (isOrderDisabledMenu(menu)) {
    return true;
  }

  // 選択肢が「すべて」売切かどうか
  const toppings = menu.toppings;
  if (!toppings || toppings.length == 0) {
    return false; // topping 本体が存在しない
  }
  const availableT = toppings.find(t => {
    const values = t.values ?? [];
    const availableV = values.some(v => !isOrderDisabledValue(v)); // 売切以外
    return availableV;
  });
  return !availableT;
}

export const isOrderDisabledCartMenu = function (menu) {
  // 売切メニューが存在するか
  if (isOrderDisabledMenu(menu)) {
    return true;
  }

  // 選択されている選択肢が売り切れかどうか
  const toppings = menu.toppings;
  if (!toppings || toppings.length == 0) {
    console.log("xx ")
    return false; // topping 本体が存在しない
  }
  const soldOutT = toppings.find(t => {
    return isOrderDisabledToppingSelected(t);
  });
  return soldOutT !== undefined;
}

export const isOrderDisabledToppingSelected = function (topping) {
  // 選択された「選択肢」が売切かどうか
  const values = topping.values;
  const selectedValue = values.find(v => v.id === topping.selected);
  return isOrderDisabledValue(selectedValue);
}

export const isOrderDisabledMenu = function (menu) {
  // 「メニュー」本体が売切かどうか
  return menu.provideStatus !== PROVIDE_STATUS.PROVIDED;
}

export const isOrderDisabledValue = function (value) {
  // 「選択肢」本体が売切かどうか
  return value.provideStatus !== PROVIDE_STATUS.PROVIDED;
}

/**
 * 共通チェック
 */
export const CHECK_TYPE = {
  SERVICE_ACTIVE: 1, // サービス稼働中かどうか
  USER_STATUS_IN_CONFIRM: 20, // ユーザ 注文状態「注文確認中」かどうか
  USER_VISIT_TIME: 21, // ユーザ 来店時刻が正当かどうか
  SHOP_STATUS_SUSPENDED: 30, // 店舗 注文状態「一時停止中」かどうか
  SHOP_STATUS_NOT_ACCEPTED: 31, // 店舗 注文状態「停止中」かどうか
  ORDER_TIME_IN_RANGE: 40, // 注文の最短受取日時が提供可能範囲内かどうか
  ORDER_AVAILABLE: 41, // 注文が有効かどうか
  MST_MENU_CHANGED: 50, // カート内メニュー「マスターと差分がある」かどうか
  MST_MENU_DELETED: 51, // カート内メニュー「マスターが削除されている」かどうか
  MST_MENU_SOLDOUT: 52, // カート内メニュー「マスターが売切れている」かどうか
};

/**
 * 共通チェック エラーMSG
 * @param {*} checkType 
 * @returns 
 */
export const createCheckErrMsg = (checkType) => {
  switch (checkType) {
    case CHECK_TYPE.SERVICE_ACTIVE:
      return MSG_SERVICE.IN_MAINTENANCE;
    //
    case CHECK_TYPE.USER_STATUS_IN_CONFIRM:
      return MSG_ORDER_NG.IN_CONFIRM;
    case CHECK_TYPE.USER_VISIT_TIME:
      return MSG_ORDER.VISIT_TIME;
    //
    case CHECK_TYPE.SHOP_STATUS_SUSPENDED:
      return MSG_ORDER_NG.SUSPENDED;
    case CHECK_TYPE.SHOP_STATUS_NOT_ACCEPTED:
      return MSG_ORDER_NG.NOT_ACCEPTED;
    //
    case CHECK_TYPE.ORDER_AVAILABLE:
      return MSG_ORDER.INVALID;
    case CHECK_TYPE.ORDER_TIME_IN_RANGE:
      return MSG_ORDER_NG.NOT_ACCEPTED;
    //
    case CHECK_TYPE.MST_MENU_CHANGED:
    case CHECK_TYPE.MST_MENU_DELETED:
      return MSG_CART.CHANGED;
    case CHECK_TYPE.MST_MENU_SOLDOUT:
      return MSG_ORDER.INVALID;
    default:
      throw Error(`not implemented: ${checkType}`);
  }
};

/**
 * カート内アイテム
 */
export const CART_ITEM = {
  OK: 0,
  // 表示値をそのままチェック
  SOLDOUT: 1,
  NOT_PUBLISH: 2,
  // 最新値取得後にチェック
  UPDATED: 3,
  DELETED: 4,
};
